import Api from "@src/api";
export const EquipmentApi= {
 
  getDataChart(params) {
    return Api().get("ChecklistHistoryDetail/GetCheckItemMachine",{params});
  },
  dowloadDataChart(params) {
    return Api().get("ChecklistHistoryDetail/download-itemcheck",{params,
      responseType: "blob",});
  },
  get2TreeSelect(params){
    return Api().get("MachineNewForSiteOffice/SearchCategoryMachine",{params});
  },
  searchTreeMachine(params){
    return Api().get("MachineNewForSiteOffice/SearchTreeMachine",{params});
  },
  createEquipment(data){
    return Api().post("MachineNewForSiteOffice/CreateNewMachine",data)
  },
  updateEquipment(data){
    return Api().put("MachineNewForSiteOffice/UpdateNewMachine",data)
  },
  upVersionEquipment(data){
    return Api().put("MachineNewForSiteOffice/ReUp",data)
  },
  getDetailByGeneration(params){
    return Api().get("MachineNewForSiteOffice/GetMachineByGeneration",{
      params
    })
  },
  getDetailEquipment(code)  {
    return Api().get("MachineNewForSiteOffice/GetMachineByCode",{
      params:{
        code
      }
    })
  },
  deleteEquipment(code){
     return Api().delete(`MachineNewForSiteOffice/Delete?code=${code}`)
  },
  getDataCheckItemAndMaitain (code) {
    return Api().get("MachineNewForSiteOffice/GetMachineByInit",{
      params:{
        code
      }
    })
   
  }
  
};
